import { Directive, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormFieldBaseComponent } from '../form-field-base.component';

@Directive()
export abstract class FormFieldInputBaseComponent<T> extends FormFieldBaseComponent<T, FormControl<string>> {
    private _isOptionalOverride: boolean | undefined = undefined;
    private _placeholderText: string = '';

    @Input()
    get isOptional(): boolean {
        return this._isOptionalOverride != undefined ? this._isOptionalOverride : !this.formControl.isRequired;
    }
    set isOptional(value: boolean) {
        this._isOptionalOverride = value;
    }

    @Input() autocorrect: boolean = false;
    @Input() maxCharacterLength: number = 255;
    @Input()   
    set placeholderText(value: string) {
        this._placeholderText = value;  
        this.UpdatePlaceHolder();  
    }

    constructor() {
        super();
        this.viewControl = new FormControl("", {nonNullable: true});
    }

    //Used for overriders
    UpdatePlaceHolder() { }

    get placeholderText(): string {
        return this._placeholderText;    
    }
}
